import store from "@/store";

import { _updateData } from "@/api/esdata";
import { checkDocumentExist } from "@/api/documentexist";
import { resendOtpMail } from "@/api/user";
import { resetPwdMail } from "@/api/user";
import { removeFromGroup } from "@/api/user";

export const settingZoneExplain = (parentVue) => {
    return {
        description: "<p>Manage users.</p>",
    };
};

export const isEnabled = (parentVue) => {
    return {
        description: "<p>Whether this user is enabled. If not, the user can't logged in.</p>",
        render: (h, params) => {
            var statusColor = params.row.isenabled ? "success" : "default";
            var status = params.row.isenabled;
            var vm = parentVue.$refs.rcmTable;
            return h("i-switch", {
                props: {
                    trueColor: statusColor,
                    value: status,
                    beforeChange() {
                        return new Promise((resolve) => {
                            vm.$Modal.confirm({
                                title: vm.$i18n.t("rcmtable.changeStatusText"),
                                content: vm.$i18n.t("rcmtable.confirmChangeStatusText"),
                                okText: vm.$i18n.t("rcmtable.confirmText"),
                                cancelText: vm.$i18n.t("rcmtable.cancelText"),
                                onOk: () => {
                                    resolve();
                                },
                            });
                        });
                    },
                },
                on: {
                    "on-change": (value) => {
                        params.row.isenabled = value;
                        delete params.row._index;
                        delete params.row._rowKey;
                        delete params.row._checked;
                        _updateData("rcm-users", "index", params.row)
                            .then((result) => {
                                vm.$Notice.success({
                                    title: vm.$i18n.t("global.success"),
                                    desc: `${result.data.message}`,
                                });
                            })
                            .catch(function (error) {
                                vm.$Notice.warning({
                                    title: vm.$i18n.t("global.error"),
                                    desc: `${error}`,
                                });
                                vm.getTableData();
                            });
                    },
                },
            });
        },
    };
};
export const username = (parentVue) => {
    var vm = parentVue.$refs.rcmTable;

    return {
        withForm: true,
        formTypes: ["createForm"],
        tooltip: true,
        formRender: "FormInput",
        defaultVal: "",
        description: "<p>The name of the user, the name within a group must be unique</p>",
        validate: [
            {
                required: true,
                message: parentVue.$i18n.t("usersmanage.userName") + parentVue.$i18n.t("rcmtable.validateEmptyText"),
                trigger: "blur",
            },
            {
                validator: (rule, value, callback, source, options) => {
                    var vm = parentVue.$refs.rcmTable;
                    if (!/^[a-z0-9\-\_\.\@]*$/.test(value))
                        return callback(
                            new Error(`${vm.$i18n.t("rcmtable.validateIllegalCharsPrefix")}: a-z 0-9 - _ . @`)
                        );
                    if (value.length > 35)
                        return callback(new Error(`${vm.$i18n.t("rcmtable.validateExceedLengthPrefix")}: 35`));
                    checkDocumentExist({
                        topic: "username",
                        fieldVal: value,
                        groupName: vm.formData.groupName,
                    }).then((result) => {
                        if (!result.data.success) {
                            return callback(new Error(`${value} ${vm.$i18n.t("rcmtable.validateExistText")}`));
                        }
                        callback();
                    });
                },
                trigger: "blur",
            },
        ],
    };
};

export const groupName = (parentVue) => {
    return {
        withForm: false,
        withTable: false,
        filter: {
            type: "string",
            searchKey: "inGroupsRole.groupName",
            defaultValue: parentVue.$store.state.queryGroupName,
        },
    };
};

export const action = (parentVue) => {
    return {
        width: 160,
        render: (h, params) => {
            var vm = parentVue.$refs.rcmTable;

            const actionDivArray = [];
            const editBtn = h("Button", {
                props: {
                    shape: "circle",
                    icon: vm.isEditBtnDisabled ? "md-eye" : "md-create",
                },
                on: {
                    click: () => {
                        vm.editItem(params.row);
                    },
                },
            });
            var dropdownItems = [
                {
                    value: "otpReset",
                    title: vm.$i18n.t("usersmanage.otpReset"),
                    apiAction: resendOtpMail,
                    modalTitle: vm.$i18n.t("usersmanage.otpReset"),
                    modalContent: vm.$i18n.t("usersmanage.otpResetText"),
                    disabled: vm.isEditBtnDisabled,
                },
                {
                    value: "pwdReset",
                    title: vm.$i18n.t("usersmanage.pwdReset"),
                    apiAction: resetPwdMail,
                    modalTitle: vm.$i18n.t("usersmanage.pwdReset"),
                    modalContent: vm.$i18n.t("usersmanage.pwdResetText"),
                    disabled: vm.isEditBtnDisabled,
                },
            ];
            if (store.getters.isInAllGroupView) {
                dropdownItems.push({
                    value: "delete",
                    title: vm.$t("rcmtable.deleteText"),
                    modalTitle: vm.$t("rcmtable.deleteText"),
                    modalContent: vm.$t("rcmtable.confirmDeleteText"),
                    disabled: vm.isDeleteBtnDisabled,
                });
            } else {
                dropdownItems.push({
                    value: "removeFromGroup",
                    title: vm.$i18n.t("usersmanage.removeFromGroup"),
                    modalTitle: vm.$i18n.t("usersmanage.removeFromGroup"),
                    modalContent: vm.$i18n.t("usersmanage.removeFromGroupText"),
                    disabled: vm.isEditBtnDisabled,
                });
            }

            const moreBtn = h(
                "Dropdown",
                {
                    props: {
                        trigger: "click",
                        placement: "right",
                        transfer: true,
                    },
                    on: {
                        "on-click": (value) => {
                            var currentItem = dropdownItems.find((e) => e.value == value);
                            vm.$Modal.confirm({
                                title: currentItem.modalTitle,
                                content: currentItem.modalContent,
                                okText: vm.$i18n.t("rcmtable.confirmText"),
                                cancelText: vm.$i18n.t("rcmtable.cancelText"),
                                onOk: () => {
                                    if (value == "delete") {
                                        var deleteItem = Object.assign({}, params.row);
                                        delete deleteItem._index;
                                        delete deleteItem._rowKey;

                                        vm.actionType = "delete";
                                        vm.updateData(vm.esIndex, "delete", deleteItem);
                                    } else if (value == "removeFromGroup") {
                                        removeFromGroup({
                                            username: params.row.username,
                                            groupName: vm.$store.state.queryGroupName,
                                        });
                                    } else {
                                        currentItem
                                            // .apiAction(params.row)
                                            .apiAction({
                                                // 提交者所在群組
                                                groupName: vm.$store.state.queryGroupName,
                                                userId: params.row.userId,
                                                username: params.row.username,
                                                inGroupsRole: params.row.inGroupsRole,
                                                email: params.row.email,
                                                _id: params.row.userId
                                            })
                                            .then((result) => {
                                                vm.$Notice.success({
                                                    title: vm.$i18n.t("global.success"),
                                                    desc: `${result.data.message}`,
                                                });
                                            })
                                            .catch(function (error) {
                                                vm.$Notice.warning({
                                                    title: vm.$i18n.t("global.error"),
                                                    desc: `${error}`,
                                                });
                                                // vm.getAllData();
                                            });
                                    }
                                },
                            });
                        },
                    },
                },
                [
                    h("a", [
                        h("Button", {
                            props: {
                                shape: "circle",
                                icon: "md-more",
                                key: params.index,
                            },
                        }),
                    ]),
                    h(
                        "DropdownMenu",
                        {
                            slot: "list",
                        },
                        [
                            dropdownItems.map(function (item) {
                                return h(
                                    "DropdownItem",
                                    {
                                        props: {
                                            name: item.value,
                                            disabled: item.disabled,
                                        },
                                    },
                                    item.title
                                );
                            }),
                        ]
                    ),
                ]
            );
            if (vm.userCanIndex) {
                actionDivArray.push(editBtn);
            }
            actionDivArray.push(moreBtn);
            return h("div", actionDivArray);
        },
    };
};



// WEBPACK FOOTER //
// ./src/view/UsersManage/fields.js